const tecURL = "/the-elder-commands"

export const tecPagesURLs = {
  home: tecURL + "",
  skills: tecURL + "/skills",
  items: tecURL + "/items",
  spells: tecURL + "/spells",
  other: tecURL + "/other",
  plugins: tecURL + "/plugins",
  commands: tecURL + "/commands",
};